var map = {
	"./AllLoanCenter.webp": 7484,
	"./AmoozeshgahAzad.webp": 6804,
	"./BarFrooshiWinAccounting.webp": 7502,
	"./BusinesseWinAccounting.webp": 2804,
	"./HanaAccounting.webp": 1127,
	"./ProductWinAccounting.webp": 5862,
	"./ResturantWinAccounting.webp": 1701,
	"./SalaryCertificate.webp": 8741,
	"./ServiceWinAccounting.webp": 442,
	"./SimpleWinAccounting.webp": 6109,
	"./TaxService.webp": 5728,
	"./VisitoryWinAccounting.webp": 5536,
	"./WorkersWinAccounting.webp": 5966,
	"./complex_school.webp": 2381,
	"./independent_school.webp": 2059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3266;